import { useMemo } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';

/**
 * 관제 화면(통합 모니터링 등)용 뷰포트 — 데스크톱 설정은 유지하고 좁은 화면에서만 레이아웃을 조정합니다.
 */
export function useMonitoringViewport(poolsPerRow: number) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isCompactToolbar = useMediaQuery(theme.breakpoints.down('lg'));

  const effectivePoolColumns = useMemo(() => {
    if (isMobile) return 1;
    if (isTablet) return Math.min(Math.max(1, poolsPerRow), 2);
    return Math.max(1, poolsPerRow);
  }, [isMobile, isTablet, poolsPerRow]);

  const stackCctvVertically = isMobile;

  return {
    isMobile,
    isTablet,
    isCompactToolbar,
    effectivePoolColumns,
    stackCctvVertically,
  };
}
